<template>
  <div class="p-g01-item-list">
    <div class="p-g01-item-list__list">
      <div
        v-for="(item, key) in items"
        :key="key"
        class="p-g01-item-list__list__wrap"
      >
        <div
          v-if="current(key) <= max"
          class="p-g01-item-list__list__wrap__panel"
        >
          <G01IconRanking
            :num="current(key)"
            class="p-g01-item-list__ranking_icon"
          />
          <div>
            <ItemListPanel
              :id="item.id"
              :img-path="getImagePath(item.premium)"
              :name="item.premium.name"
              :point="item.premium.point_required"
              :discount-rate="0"
              :color="getColor(item.quantity)"
              :is-favorite="item.premium.is_featured"
              :status="item.premium.is_new"
              :stock="item.quantity"
              :stock-control="item.is_quantity_control"
            />
          </div>
        </div>
      </div>
    </div>
    <template v-if="items.length > 4">
      <div class="p-g01-item-list__more">
        <a
          href="javascript:void(0);"
          v-if="!isAll"
          @click="showAll"
          class="p-g01-item-list__more__link"
          :style="{ color: colorCode }"
        >
          <span>{{ items.length }}位までみる</span>
          <IconBase
            view-box="0 0 24 24"
            width="24"
            height="24"
            :icon-color="colorCode"
            class="p-g01-item-list__more__link__icon"
          >
            <IconArrowBottom />
          </IconBase>
        </a>
        <template v-if="isCategory">
          <div class="p-g01-item-list__more__button">
            <ButtonMain :tag="'a'" href="/b01/" kind="secondary"
              >このカテゴリーの商品をもっと見る</ButtonMain
            >
          </div>
        </template>
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import ItemListPanel from "@/general/components/molecules/ItemListPanel.vue";
import G01IconRanking from "@/general/components/pages/parts/Ranking/G01IconRanking.vue";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconArrowBottom from "@/common/components/icons/IconArrowBottom.vue";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";
import { Options, Vue } from 'vue-class-component';
import commons from "@/common/store/modules/commons";

@Options({
  props: {
    items: { type: Array, required: true },
    isCategory: { type: Boolean, required: true, default: true }
  },
  components: {
    ItemListPanel,
    G01IconRanking,
    IconBase,
    IconArrowBottom,
    ButtonMain
  }
})
export default class G01ItemList extends Vue {
  items!: any;
  isCategory!: boolean;

  isAll = false;

  get colorCode() {
    return commons?.OrgPageSpecific?.page_color;
  }

  get current() {
    return function(key: any) {
      return key + 1;
    };
  }
  get max() {
    return this.isAll ? 10 : 4;
  }

  showAll() {
    this.isAll = true;
  }

  getImagePath(premium: any) {
    let imgUrl = "";
    premium?.premiumimage_set?.forEach((img: any) => {
      if (img?.is_primary == true) {
        imgUrl = img?.image_url;
      }
    });
  }
  getColor(stock: any) {
    return stock > 0 ? commons.colorCode : "#333";
  }
}
</script>

<style lang="scss" scoped>
.p-g01-item-list {
  &__list {
    display: flex;
    flex-wrap: wrap;
    margin: rem(-16) rem(-8) 0 0;

    &__wrap {
      width: 50%;

      &__panel {
        padding: rem(16) rem(8) 0 0;
      }
    }
  }

  &__ranking_icon {
    margin: 0 0 rem(8) rem(8);
    display: flex;
    align-items: center;
  }

  &__more {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: rem(24) auto 0;

    &__link {
      @include text__body--s;
      font-weight: bold;
      display: flex;
      align-items: center;

      &__icon {
        margin-left: rem(4);
      }
    }

    &__button {
      margin-top: rem(16);
    }
  }
}
</style>
